const weekDaysNames = {
  1: 'SI_MONDAY',
  2: 'SI_TUESDAY',
  3: 'SI_WEDNESDAY',
  4: 'SI_THURSDAY',
  5: 'SI_FRIDAY',
  6: 'SI_SATURDAY',
  7: 'SI_SUNDAY'
};

const weekDaysNamesMin = {
  1: 'SI_MONDAY_MIN',
  2: 'SI_TUESDAY_MIN',
  3: 'SI_WEDNESDAY_MIN',
  4: 'SI_THURSDAY_MIN',
  5: 'SI_FRIDAY_MIN',
  6: 'SI_SATURDAY_MIN',
  7: 'SI_SUNDAY_MIN'
};

const weekDaysBinary = {
  1: '1000000',
  2: '0100000',
  3: '0010000',
  4: '0001000',
  5: '0000100',
  6: '0000010',
  7: '0000001'
};

const weekDaysValues = [
  {
    id: 1,
    name: weekDaysNames[1],
  },
  {
    id: 2,
    name: weekDaysNames[2]
  },
  {
    id: 3,
    name: weekDaysNames[3]
  },
  {
    id: 4,
    name: weekDaysNames[4]
  },
  {
    id: 5,
    name: weekDaysNames[5]
  },
  {
    id: 6,
    name: weekDaysNames[6]
  },
  {
    id: 7,
    name: weekDaysNames[7]
  }
];

export {
  weekDaysNames,
  weekDaysNamesMin,
  weekDaysBinary,
  weekDaysValues
};
